import BarChartComponent from '@/components/ui/charts/BarChartComponent';
import { useMemo } from 'react';

export type WeeklyConsultationsByDayProps = {
    data: Array<{ day: string, completedCount: number, scheduledCount: number }>;
    title: string;
}

function WeeklyConsultationsByDayComponent(props: WeeklyConsultationsByDayProps) {
    const { data, title } = props;

    const transformedData = useMemo(() => [{
        label: 'Completed',
        values: data.map(item => ({ subLabel: item.day, value: item.completedCount }))
    }, {
        label: 'Scheduled',
        values: data.map(item => ({ subLabel: item.day, value: item.scheduledCount }))
    }], [data]);

    return <BarChartComponent data={transformedData} title={`${title}`} />;
}

export default WeeklyConsultationsByDayComponent;
